import React, { Component } from 'react';
import Css from '@components/Header/Desktop/Desktop.scss';
import { Link } from 'react-router-dom';
import ImportImages from '@src/importImages';

const Logo = ImportImages('/logo.png');

class Header extends Component {
  render() {
    return (
      <header className={Css.header + ' d-flex align-items-center pl-3 pr-3'}>
        <Link to={'/'} className={'nav-anhor mx-auto d-none'} data-goto={0}>
          <img
            src={Logo}
            className={'img-fluid float-left mr-3'}
            alt={'JetSuite Logo'}
          />
        </Link>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderSimple.jsx